import * as React from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from '../../components/store.js';
import { DeviceComponent } from './DeviceComponent';
import { KitViewComponent } from '../kitboard/kit-view/kit-view.component.js';

export function DeviceComponentLayout() {
  return (
    <Provider store={store}>
      <div>
        <BrowserRouter>
          <Switch>
            <Route path={"/Devices"} component={DeviceComponent}/>
            <Route path="/kit-view/:deviceId" component={KitViewComponent} />
          </Switch>
        </BrowserRouter>
      </div>
    </Provider>
  );
}
